module.exports = __webpack_public_path__ + "img/CM-DJ-24-Ford-Playful.c136007e.jpg";